import { cn } from '@/lib/utils';

interface Step {
  id: string;
  label: string;
}

interface StepIndicatorProps {
  steps: Step[];
  currentStep: string;
  className?: string;
}

export function StepIndicator({ steps, currentStep, className }: StepIndicatorProps) {
  return (
    <div className={cn("flex items-center justify-center space-x-2", className)}>
      {steps.map((step, index) => {
        const isActive = step.id === currentStep;
        const isCompleted = steps.findIndex(s => s.id === currentStep) > index;

        return (
          <div key={step.id} className="flex items-center">
            {index > 0 && (
              <div 
                className={cn(
                  "h-px w-16 mx-2",
                  isCompleted ? "bg-primary" : "bg-border"
                )}
              />
            )}
            <div 
              className={cn(
                "flex flex-col items-center gap-1",
                (isActive || isCompleted) && "text-primary"
              )}
            >
              <div 
                className={cn(
                  "h-8 w-8 rounded-full border-2 flex items-center justify-center text-sm font-medium",
                  isActive && "border-primary text-primary",
                  isCompleted && "bg-primary border-primary text-primary-foreground",
                  !isActive && !isCompleted && "border-border text-muted-foreground"
                )}
              >
                {isCompleted ? '✓' : index + 1}
              </div>
              <span className="text-xs font-medium">{step.label}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
} 